// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FbsuC","question":"styles_question__3YHks","description":"styles_description__29kf6"};